module.exports = __webpack_public_path__ + "static/media/categoryImage.9cdfdcef.png";